// Choix du mode de livraison et du point relais Mondial Relay (relais commerçant ou locker)
// dans le panier (snippet alnatea-relais). Colis Privé remplacé par Mondial Relay le 2026-10-09.
// Recherche par code postal dans l'annuaire Sendcloud (clé publique, CORS autorisé pour le site),
// liste des relais les plus proches intégrée au bloc, avec une petite carte numérotée (Leaflet +
// OpenStreetMap, gratuites et sans clé) téléchargée seulement quand des relais sont affichés.
// Dans le tiroir sur mobile, la carte est repliée derrière « Voir sur la carte ».
// Écouteurs posés sur document : le tiroir panier de Dawn remplace son HTML à chaque modification,
// les blocs sont donc retrouvés à chaque événement.
(() => {
  const ANNUAIRE = 'https://servicepoints.sendcloud.sc/api/v2/service-points/';
  const RAYONS = [5000, 20000, 50000]; // élargi tant qu'on a moins de 3 relais (zones rurales)
  const MAX = 5;
  const JOURS = ['Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.', 'Dim.']; // Sendcloud : 0 = lundi
  const TRANSPORTEUR = 'mondial_relay'; // code Sendcloud, recopié dans delivery_point_carrier
  const CHAMPS = ['delivery_point_code', 'delivery_point_id', 'delivery_point_name', 'delivery_point_address', 'delivery_point_postcode', 'delivery_point_city', 'delivery_point_carrier', 'delivery_point_type'];
  let enCours = null; // dernière écriture des attributs, attendue avant de partir au paiement
  let resultats = []; // derniers relais trouvés (partagés entre tiroir et page)
  const LEAFLET = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/';
  const SRI = {
    js: 'sha384-cxOPjt7s7Iz04uaHJceBmS+qpjv2JkIHNVcuOrM+YHwZOmJGBXI00mdUXEq65HTH',
    css: 'sha384-sHL9NAb7lN7rfvG5lfHpm643Xkcjzp4jFvuavGOndn6pjVqS6ny56CAt3nsEVT4H',
  };
  let leaflet = null;

  const blocs = () => document.querySelectorAll('[data-alnatea-relais]');

  const majPanier = (attributs) =>
    (enCours = fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributs }),
    }).finally(() => (enCours = null)));

  // « VICENT & CO » → « Vicent & Co » (affichage seulement : les attributs gardent la graphie du transporteur).
  const casse = (t) => (t || '').toLowerCase().replace(/(^|[\s\-'’(])(\p{L})/gu, (m, a, b) => a + b.toUpperCase());
  const distance = (m) => (m < 1000 ? `${Math.round(m / 10) * 10} m` : `${(m / 1000).toFixed(1).replace('.', ',')} km`);
  const heure = (h) => h.replace(/^0/, '').replace(/ - 0?/, '-');

  // Horaires regroupés par jours consécutifs identiques : « Lun. 15:30-19:30 · Mar.-Sam. 9:30-19:30 ».
  const horaires = (o) => {
    if (!o) return '';
    const jours = JOURS.map((_, i) => (o[i] || []).map(heure).join(', '));
    const morceaux = [];
    for (let i = 0; i < 7; i++) {
      if (!jours[i]) continue;
      let j = i;
      while (j < 6 && jours[j + 1] === jours[i]) j++;
      morceaux.push(`${JOURS[i]}${j > i ? '-' + JOURS[j] : ''} ${jours[i]}`);
      i = j;
    }
    return morceaux.join(' · ');
  };

  const attributsDe = (sp) => ({
    delivery_point_code: sp.code,
    delivery_point_id: String(sp.id),
    delivery_point_name: sp.name,
    delivery_point_address: [sp.house_number, sp.street].filter(Boolean).join(' '),
    delivery_point_postcode: sp.postal_code,
    delivery_point_city: sp.city,
    delivery_point_carrier: TRANSPORTEUR,
    // « Locker » ou « Relais » : Base en déduit la méthode d'étiquette (Locker Delivery ou Point Relais).
    delivery_point_type: sp.general_shop_type === 'locker' ? 'Locker' : 'Relais',
  });

  // Reporte l'état sur tous les blocs présents (tiroir et page panier).
  const afficher = ({ mode, point, recherche, message, liste }) => {
    for (const b of blocs()) {
      if (mode) {
        const radio = b.querySelector(`input[value="${mode}"]`);
        if (radio) radio.checked = true;
        b.querySelector('.alnatea-relais__choix').hidden = mode !== 'Point relais';
        b.querySelector('.alnatea-relais__erreur').hidden = true;
      }
      if (point !== undefined) {
        b.querySelector('.alnatea-relais__point').hidden = !point;
        if (point) {
          b.querySelector('[data-relais-nom]').textContent = casse(point.delivery_point_name);
          b.querySelector('[data-relais-adresse]').textContent =
            `${casse(point.delivery_point_address)}, ${point.delivery_point_postcode} ${casse(point.delivery_point_city)}`;
        }
      }
      if (recherche !== undefined) b.querySelector('.alnatea-relais__recherche').hidden = !recherche;
      if (message !== undefined) b.querySelector('[data-relais-message]').textContent = message;
      if (liste) b.querySelector('[data-relais-liste]').innerHTML = liste;
    }
  };

  const chargerLeaflet = () =>
    (leaflet ||= new Promise((ok, ko) => {
      const css = Object.assign(document.createElement('link'), { rel: 'stylesheet', href: LEAFLET + 'leaflet.css', integrity: SRI.css, crossOrigin: 'anonymous' });
      const js = Object.assign(document.createElement('script'), { src: LEAFLET + 'leaflet.js', integrity: SRI.js, crossOrigin: 'anonymous' });
      js.onload = ok;
      js.onerror = () => { leaflet = null; ko(new Error('Carte indisponible')); };
      document.head.append(css, js);
    }));

  const replier = (b) => !!b.closest('cart-drawer') && window.matchMedia('(max-width: 749px)').matches;

  // Met en évidence le relais n° i dans la liste et sur la carte.
  const surligner = (b, i, depuisCarte) => {
    const liste = b.querySelector('[data-relais-liste]');
    [...liste.children].forEach((li, j) => li.classList.toggle('alnatea-relais__item--actif', i === j));
    b._reperes?.forEach((m, j) => m.getElement()?.classList.toggle('alnatea-relais__repere--actif', i === j));
    if (depuisCarte) liste.scrollTo({ top: liste.children[i].offsetTop, behavior: 'smooth' });
    else b._carte?.panTo(b._reperes[i].getLatLng());
  };

  const dessiner = async (b) => {
    const zone = b.querySelector('[data-relais-carte]');
    try {
      await chargerLeaflet();
    } catch (e) {
      console.error(e);
      zone.hidden = true;
      b.querySelector('[data-relais-voir-carte]').hidden = true;
      return;
    }
    if (b._carte || zone.hidden || !resultats.length || !b.isConnected) return;
    const L = window.L;
    const carte = L.map(zone, { scrollWheelZoom: false });
    carte.attributionControl.setPrefix(false);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '© OpenStreetMap' }).addTo(carte);
    b._reperes = resultats.map((p, i) =>
      L.marker([Number(p.latitude), Number(p.longitude)], {
        title: casse(p.name),
        icon: L.divIcon({ className: 'alnatea-relais__repere', html: String(i + 1), iconSize: [26, 26], iconAnchor: [13, 13] }),
      })
        .on('click', () => surligner(b, i, true))
        .addTo(carte)
    );
    carte.fitBounds(L.latLngBounds(b._reperes.map((m) => m.getLatLng())), { padding: [24, 24], maxZoom: 15 });
    b._carte = carte;
  };

  // Carte dessinée d'office dans le bloc où l'on a cherché (sauf tiroir sur mobile) ; ailleurs, repliée.
  const majCartes = (bloc) => {
    for (const b of blocs()) {
      b._carte?.remove();
      b._carte = null;
      b._reperes = null;
      const zone = b.querySelector('[data-relais-carte]');
      const voir = b.querySelector('[data-relais-voir-carte]');
      const ouverte = resultats.length > 0 && b === bloc && !replier(b);
      zone.hidden = !ouverte;
      voir.hidden = !resultats.length || ouverte;
      voir.textContent = 'Voir sur la carte';
      if (ouverte) dessiner(b);
    }
  };

  const echapper = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  const chercher = async (bloc) => {
    const champ = bloc.querySelector('[data-relais-cp]');
    const cp = champ.value.replace(/\s/g, '');
    for (const b of blocs()) b.querySelector('[data-relais-cp]').value = cp;
    if (!/^\d{5}$/.test(cp)) {
      afficher({ message: 'Indiquez un code postal à 5 chiffres.', liste: ' ' });
      champ.focus();
      return;
    }
    afficher({ message: 'Recherche des points relais…', liste: ' ' });
    resultats = [];
    majCartes();
    try {
      let trouves = [];
      for (const rayon of RAYONS) {
        const url = `${ANNUAIRE}?country=FR&carrier=${TRANSPORTEUR}&address=${cp}&radius=${rayon}&access_token=${encodeURIComponent(bloc.dataset.cle)}`;
        const r = await fetch(url);
        if (!r.ok) throw new Error(`Annuaire ${r.status}`);
        // Relais commerçants et lockers Mondial Relay, mêlés par distance.
        trouves = (await r.json()).filter((p) => p.is_active !== false);
        if (trouves.length >= 3) break;
      }
      resultats = trouves.sort((a, b) => (a.distance ?? 0) - (b.distance ?? 0)).slice(0, MAX);
      if (!resultats.length) {
        afficher({ message: 'Aucun point relais à moins de 50 km de ce code postal. Choisissez la livraison à domicile.', liste: ' ' });
        return;
      }
      afficher({
        message: `${resultats.length} point${resultats.length > 1 ? 's' : ''} relais près de ${cp} :`,
        liste: resultats
          .map(
            (p, i) => `<li class="alnatea-relais__item">
              <span class="alnatea-relais__num" aria-hidden="true">${i + 1}</span>
              <div><strong>${echapper(casse(p.name))}</strong>${p.general_shop_type === 'locker' ? ' <span class="alnatea-relais__type">Locker</span>' : ''}${p.distance != null ? ` <span class="alnatea-relais__distance">à ${distance(p.distance)}</span>` : ''}<br>
              <span>${echapper(casse([p.house_number, p.street].filter(Boolean).join(' ')))}, ${echapper(p.postal_code)} ${echapper(casse(p.city))}</span><br>
              <span class="alnatea-relais__horaires">${echapper(horaires(p.formatted_opening_times))}</span></div>
              <button type="button" class="button button--secondary alnatea-relais__retenir" data-relais-retenir="${i}">Choisir</button>
            </li>`
          )
          .join(''),
      });
      majCartes(bloc);
    } catch (e) {
      console.error(e);
      afficher({ message: 'La recherche de points relais est momentanément indisponible. Réessayez ou choisissez la livraison à domicile.', liste: ' ' });
    }
  };

  const relaisManquant = () =>
    [...blocs()].some(
      (b) => b.querySelector('input[value="Point relais"]').checked && b.querySelector('.alnatea-relais__point').hidden
    );

  // Les boutons Shop Pay / PayPal de la page panier (iframes, clic non interceptable) sont masqués
  // tant que « Point relais » est coché sans relais choisi.
  const majExpress = () => document.documentElement.classList.toggle('alnatea-relais-manquant', relaisManquant());
  document.addEventListener('click', () => setTimeout(majExpress, 0));
  document.addEventListener('change', () => setTimeout(majExpress, 0));
  majExpress();

  document.addEventListener('change', (e) => {
    const radio = e.target.closest('[data-alnatea-relais] input[type="radio"]');
    if (!radio) return;
    if (radio.value === 'Domicile') {
      afficher({ mode: 'Domicile', point: null, recherche: true, message: '', liste: ' ' });
      majPanier(Object.fromEntries([['Mode de livraison', 'Domicile'], ...CHAMPS.map((c) => [c, ''])]));
    } else {
      afficher({ mode: 'Point relais' });
      majPanier({ 'Mode de livraison': 'Point relais' });
      const bloc = radio.closest('[data-alnatea-relais]');
      const cp = bloc.querySelector('[data-relais-cp]');
      if (!bloc.querySelector('.alnatea-relais__recherche').hidden) (cp.value ? chercher(bloc) : cp.focus());
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' || !e.target.matches('[data-relais-cp]')) return;
    e.preventDefault();
    chercher(e.target.closest('[data-alnatea-relais]'));
  });

  document.addEventListener('click', (e) => {
    const bloc = e.target.closest('[data-alnatea-relais]');
    if (e.target.closest('[data-relais-chercher]')) return chercher(bloc);
    if (e.target.closest('[data-relais-changer]')) {
      afficher({ recherche: true }); // l'ancien relais reste retenu tant qu'aucun autre n'est choisi
      const cp = bloc.querySelector('[data-relais-cp]');
      return cp.value ? chercher(bloc) : cp.focus();
    }
    const voir = e.target.closest('[data-relais-voir-carte]');
    if (voir) {
      const zone = bloc.querySelector('[data-relais-carte]');
      zone.hidden = !zone.hidden;
      voir.textContent = zone.hidden ? 'Voir sur la carte' : 'Masquer la carte';
      if (!zone.hidden) (bloc._carte ? bloc._carte.invalidateSize() : dessiner(bloc));
      return;
    }
    const retenir = e.target.closest('[data-relais-retenir]');
    if (retenir) {
      const point = attributsDe(resultats[Number(retenir.dataset.relaisRetenir)]);
      afficher({ mode: 'Point relais', point, recherche: false, message: '', liste: ' ' });
      majPanier({ 'Mode de livraison': 'Point relais', ...point });
      return;
    }
    const item = e.target.closest('.alnatea-relais__item');
    if (item) return surligner(bloc, [...item.parentElement.children].indexOf(item), false);

    const paiement = e.target.closest('[name="checkout"]');
    if (!paiement) return;
    // Attributs encore en cours d'écriture : on attend, puis on relance le clic.
    if (enCours) {
      e.preventDefault();
      e.stopImmediatePropagation();
      enCours.then(() => paiement.click(), () => paiement.click());
      return;
    }
    // Paiement bloqué tant que « Point relais » est coché sans relais choisi.
    if (relaisManquant()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      for (const b of blocs()) b.querySelector('.alnatea-relais__erreur').hidden = false;
      const visible = [...blocs()].find((b) => b.offsetParent) || blocs()[0];
      visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);
})();
